import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Home from "./core/Home";
import Signin from "./user/Signin";
import Signup from "./user/Signup";
import AdminRoute from "./auth/helper/AdminRoute";
import PrivateRoute from "./auth/helper/PrivateRoute";
import UserDashBoard from "./user/UserDashBoard";
import AdminHome from "./user/AdminHome";
import AddCategory from "./auth/AddCategory";
import ManageCategories from "./auth/ManageCategories";
import AddProduct from "./auth/AddProduct";
import ManageProducts from "./auth/ManageProducts";
import UpdateProduct from "./auth/UpdateProduct";
import UpdateCategory from "./auth/UpdateCategory";
import Cart from "./core/Cart";
import NotFound from "./core/NotFound";
import ManageOrders from "./auth/ManageOrders";
import UserOrders from "./user/UserOrders";

const Routes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/signup" exact component={Signup} />
        <Route path="/signin" exact component={Signin} />
        <Route path="/cart" exact component={Cart} />
        <PrivateRoute path="/user/dashboard" exact component={UserDashBoard} />
        <PrivateRoute path="/user/orders" exact component={UserOrders} />
        <AdminRoute path="/admin/dashboard" exact component={AdminHome} />
        <AdminRoute
          path="/admin/create/category"
          exact
          component={AddCategory}
        />
        <AdminRoute
          path="/admin/categories"
          exact
          component={ManageCategories}
        />

        <AdminRoute path="/admin/create/product" exact component={AddProduct} />
        <AdminRoute path="/admin/products" exact component={ManageProducts} />
        <AdminRoute
          path="/admin/product/update/:productId"
          exact
          component={UpdateProduct}
        />
        <AdminRoute
          path="/admin/category/update/:categoryId"
          exact
          component={UpdateCategory}
        />
        <AdminRoute path="/admin/orders" exact component={ManageOrders} />

        <Route path="/" component={NotFound} />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
